module.exports = __webpack_public_path__ + "img/Lsg_Frequenz.fce6a362.jpg";